import { useEffect, useRef, useState } from "react";

// for getting with element
export const useWidth = () => {
  const [withElement, setWidthElement] = useState("");
  const parentRef = useRef(null);

  useEffect(() => {
    const updateWidth = () => {
      if (parentRef.current) {
        const parentWidth = parentRef.current.clientWidth;
        setWidthElement(`${parentWidth}px`);
      }
    };

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  return { withElement, parentRef };
};
